import {createSlice} from "@reduxjs/toolkit";

const initialSelectedUserState = {
  isLoading: false,
  data: {},
  safeLocks:null,
  searchedInstrument: null,
  selectedInstrument: null,
  bankList: null,
  bankAccountName: null,
  notification: null,
  showCreateAccountModal: false
};

export const selectedUserSlice = createSlice({
  name: "selectedUser",
  initialState: initialSelectedUserState,
  reducers: {
    // Selected User Responses
    userNotification: (state, action) => {
      state.isLoading = false;
      state.notification = action.payload.notification;
    },
    // Selected Process Loading
    isLoading: (state, action) => {
      state.isLoading = true;
    },

    // Toggle Show Create Trading Account Modal
    toggleShowCreateAccountModal: (state, action) => {
      state.showCreateAccountModal = !state.showCreateAccountModal;
    },

    // fetchSelectedUser
    userProfileFetched: (state, action) => {
      state.isLoading = false;
      state.data = {profile: action.payload};
    },


    // update User Profile
    userProfileUpdated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },
    
    // deleteUser
    userDeleted: (state, action) => {
      state.notification = {type: "success", message: "User Account Deleted Successful"};
      state.data = state.data.filter(el => el.id !== action.payload.id);
    },
    

    /**********************************************************************
     * 
     * ACCOUNT SLICE
     * 
     *************************************************************************************************************/

    userAccountsFetched: (state, action) => {
      state.isLoading = false;
      // Update and Not Upsert Account Data if exist
      state.data.accounts = action.payload.map((acc, i) => ({...(state.data.accounts && state.data.accounts[i] ? state.data.accounts[i] : {}), ...acc}));
    },

    userAccountDetailsFetched: (state, action) => {
      state.isLoading = false;
      const { accountId, data } = action.payload;

      if (!state.data.accounts) {
        state.data.accounts = [];
      }

      const accountIndex = state.data.accounts.findIndex(acc => acc.accountId === accountId);

      if (accountIndex > -1) {
        state.data.accounts[accountIndex] = {
          ...state.data.accounts[accountIndex],
          details: {
            ...state.data.accounts[accountIndex].details,
            ...data,
            orders: data.orders, // Explicitly update orders
            payments: data.payments || data.history || [], // Explicitly update payments
          }
        };
      } else {
        state.data.accounts.push({
          accountId,
          details: {
            ...data,
            orders: data.orders,
            payments: data.payments || data.history || [],
          }
        });
      }
    },

    // createTradingAccount
    tradingAccountCreated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    // createReservedAccount
    reserveAccountCreated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    // updateReserveAccountInstant
    reserveAccountInstantUpdated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },
    
    // cancelAccountOrder
    accountOrderCancelled: (state, action) => {
      state.notification = {type: "success", message: action.payload.message};
    },
    
    // getSearchInstruments
    instrumentsFetched: (state, action) => {
      state.isLoading = false;
      state.searchedInstrument = action.payload.data;
    },
    
    // getInstrumentDetails
    instrumentDetails: (state, action) => {
      state.isLoading = false;
      state.selectedInstrument = action.payload.data;
    },

    // Create Order Action
    orderActionCreated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },
    
    // Create Withdrawal Action
    withdrawalCreated: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    /**********************************************************************
     * 
     * DOCUMENT SLICE
     * 
     *************************************************************************************************************/

    userDocumentsFetched: (state, action) => {
      state.isLoading = false;
      state.data.documents = action.payload;
    },

    userDocumentUploaded: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    /**********************************************************************
     * 
     * BANK ACCOUNT SLICE
     * 
     *************************************************************************************************************/

    banksFetched: (state, action) => {
      state.isLoading = false;
      state.bankList = action.payload;
    },

    bankAccountNameFetched: (state, action) => {
      state.isLoading = false;
      state.bankAccountName = action.payload;
    },

    userBankAccountsFetched: (state, action) => {
      state.isLoading = false;
      state.data.bankAccounts = action.payload;
    },

    bankAccountAdded: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    bankAccountDeleted: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    /**********************************************************************
     * 
     * SAVED CARD SLICE
     * 
     *************************************************************************************************************/

    userSavedCardsFetched: (state, action) => {
      state.isLoading = false;
      state.data.savedCards = action.payload;
  
    },

    savedCardDeleted: (state, action) => {
      state.isLoading = false;
      state.notification = {type: "success", message: action.payload.message};
    },

    /**********************************************************************
     * 
     * EARN SLICE
     * 
     *************************************************************************************************************/

     userSafeLocksFetched: (state, action) => {
      state.isLoading = false;
      state.data.safeLocks = action.payload;
    },
    
    userLiquidationsFetched: (state, action) => {
      state.isLoading = false;
      state.data.liquidations = action.payload;
    }



  }
});
